import React from "react";
import ConnectingButtons from "./ConnectingButtons";
import { connect } from "react-redux";
import "./dashboard.css";
import { setIsRoomHost } from "../store/actions";
import { useEffect } from "react";

const Dashboard = ({ setIsRoomHostAction }) => {
  useEffect(() => {
    setIsRoomHostAction(false);
  }, []);
  return (
    <div className="introduction_page_container">
      <div className="introduction_page_panel">
        <img src="" alt="" className="introduction_page_image" />
        <ConnectingButtons />
      </div>
    </div>
  );
};

const mapActionsToProps = (dispatch) => {
  return {
    setIsRoomHostAction: (isRoomHost) => dispatch(setIsRoomHost(isRoomHost)),
  };
};

export default connect(null, mapActionsToProps)(Dashboard);
